import React from 'react';
import { TileLayer } from 'react-leaflet';
import { latLngBounds } from 'leaflet';
import {
  TILE_URL,
  TILE_ATTRIBUTION,
  TILE_SPLIT_ZOOM,
  TILE_DETAIL_BOUNDS,
} from '../../enum';

// Einmal erzeugt: ein bei jedem Render neues Objekt wuerde Leaflet dazu bringen,
// den Kachel-Layer jedes Mal neu aufzubauen.
const DETAIL_BOUNDS = latLngBounds(TILE_DETAIL_BOUNDS);

/**
 * Die Kartenkacheln des eigenen Tileservers, in zwei Ebenen.
 *
 * Die Kacheln entstehen in zwei Durchgaengen (siehe build-tiles.sh): bis
 * TILE_SPLIT_ZOOM fuer Deutschland und die Nachbarlaender, darueber nur noch
 * fuer die Detailregion. Beide Ebenen brauchen deshalb eigene Grenzen:
 *
 *  - Die untere deckt alles ab. maxNativeZoom sorgt dafuer, dass oberhalb des
 *    Splits weiter die letzte gebaute Stufe angefragt und hochskaliert wird -
 *    sonst bliebe die Karte ausserhalb der Detailregion beim Hineinzoomen leer.
 *  - Die obere legt die scharfen Kacheln darueber, aber nur innerhalb der
 *    Detailregion. bounds haelt Leaflet davon ab, anderswo Kacheln anzufragen,
 *    die es nicht gibt - deren leere Bilder wuerden sonst die untere Ebene
 *    verdecken.
 *
 * Oberhalb der hoechsten gebauten Stufe fragt die obere Ebene bewusst weiter
 * echte Kacheln an, statt die letzte hochzuskalieren: tileserver-gl rendert
 * dort aus den Vektordaten neu und liefert damit ein schaerferes Bild als
 * vergroesserte Rasterkacheln. Verifiziert bis z19.
 */
export default function MapTileLayers() {
  return (
    <>
      <TileLayer
        attribution={TILE_ATTRIBUTION}
        url={TILE_URL}
        maxNativeZoom={TILE_SPLIT_ZOOM}
        updateWhenZooming={false}
        keepBuffer={2}
      />
      <TileLayer
        url={TILE_URL}
        minZoom={TILE_SPLIT_ZOOM + 1}
        bounds={DETAIL_BOUNDS}
        updateWhenZooming={false}
        keepBuffer={2}
      />
    </>
  );
}
